import { Card, CardEyebrow, CardTitle, CardContent, MetricTile } from '@bookrcs/ui';

export default function PilotageRoute() {
  return (
    <div className="grid gap-6 max-w-5xl">
      <header>
        <p className="text-[var(--text-muted)] m-0">Pilotage</p>
        <h1 className="font-serif text-4xl md:text-5xl font-extrabold m-0 mt-1 text-[var(--text)]">
          KPI 30 jours
        </h1>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <MetricTile label="RDV honorés" value="—" />
        <MetricTile label="No-show" value="—" tone="warning" />
        <MetricTile label="Revenu" value="—" tone="success" />
        <MetricTile label="NPS proxy" value="—" />
      </div>

      <Card>
        <CardEyebrow>Détails</CardEyebrow>
        <CardTitle>Branchement KPI à venir</CardTitle>
        <CardContent>
          <p className="text-[var(--text-muted)] m-0">
            Tuiles connectées à <code className="font-mono text-[var(--text)]">/pros/:id/kpi</code>{' '}
            (T6.5). Cible V1 : no-show -50% vs baseline pré-BOOKRCS (V1-SCOPE § Done #3).
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
